import React from 'react';
import { Drawer as AntDrawer, DrawerProps as AntDrawerProps } from 'antd';
import theme from '@css/theme';
import { DrawerHeader } from './next/header';
import { DrawerBody } from './next/body';
import { DrawerFooter } from './next/footer';

const DEFAULT_HEADER_STYLE = {
  padding: `${theme.token.paddingLG}px`,
  borderBottom: `1px solid ${theme.token.colorBorder}`,
  color: `${theme.token.colorText}`,
};

interface DrawerComponentProps extends AntDrawerProps {
  variant?: 'next';
}

const DrawerBase = ({
  title,
  open,
  onClose,
  children,
  bodyStyle = DEFAULT_HEADER_STYLE,
  placement,
  variant,
  width,
  ...props
}: DrawerComponentProps) => {
  if (variant === 'next') {
    return (
      <AntDrawer
        open={open}
        onClose={onClose}
        placement={placement}
        width={width ?? 320}
        closable={false}
        title={null}
        maskStyle={{ backgroundColor: 'transparent' }}
        headerStyle={{ display: 'none' }}
        bodyStyle={{
          padding: 0,
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
        }}
        {...props}
      >
        {children}
      </AntDrawer>
    );
  }

  return (
    <AntDrawer
      title={title}
      placement={placement}
      closable={false}
      onClose={onClose}
      open={open}
      width={width ?? 480}
      headerStyle={{
        padding: `${theme.token.paddingLG}px`,
        borderBottom: `1px solid ${theme.token.colorBorder}`,
        color: `${theme.token.colorText}`,
      }}
      bodyStyle={bodyStyle}
      {...props}
    >
      {children}
    </AntDrawer>
  );
};

export const Drawer = Object.assign(DrawerBase, {
  Header: DrawerHeader,
  Body: DrawerBody,
  Footer: DrawerFooter,
});

export type { DrawerProps } from 'antd';
